"use strict";

function padNumber(e) {
  return e = "00" + e, e.substring(e.length - 2, e.length);
}

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var e = 0, r = 0, t = arguments.length; r < t; r++) {
    e += arguments[r].length;
  }

  for (var o = Array(e), s = 0, r = 0; r < t; r++) {
    for (var n = arguments[r], a = 0, u = n.length; a < u; a++, s++) {
      o[s] = n[a];
    }
  }

  return o;
};

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.log = void 0, exports.log = function (e) {
  console.log.apply(console, __spreadArrays([padNumber(e.time.getHours()) + ":" + padNumber(e.time.getMinutes()) + ":" + padNumber(e.time.getSeconds())], e.text));
};